import React from 'react';
import Icon from '../../../components/AppIcon';

const CategoryChips = ({ categories = [] }) => {
  const getCategoryIcon = (category) => {
    const iconMap = {
      marketing: 'Megaphone',
      legal: 'Scale',
      image: 'Image',
      video: 'Video',
      technical: 'Code',
      business: 'Briefcase',
      creative: 'Palette',
      content: 'FileText'
    };
    return iconMap?.[category?.toLowerCase()] || 'Tag';
  };

  const getCategoryColor = (category) => {
    const colorMap = {
      marketing: 'bg-blue-100 text-blue-700 border-blue-200',
      legal: 'bg-purple-100 text-purple-700 border-purple-200',
      image: 'bg-green-100 text-green-700 border-green-200',
      video: 'bg-red-100 text-red-700 border-red-200',
      technical: 'bg-gray-100 text-gray-700 border-gray-200',
      business: 'bg-orange-100 text-orange-700 border-orange-200',
      creative: 'bg-pink-100 text-pink-700 border-pink-200',
      content: 'bg-indigo-100 text-indigo-700 border-indigo-200'
    };
    return colorMap?.[category?.toLowerCase()] || 'bg-slate-100 text-slate-700 border-slate-200';
  };

  if (!categories?.length) return null;

  return (
    <div className="w-full max-w-4xl mx-auto mb-8">
      <div className="text-center mb-4">
        <h3 className="text-lg font-semibold text-text-primary mb-2">
          AI Classification Results
        </h3>
        <p className="text-sm text-text-secondary">
          Our AI has categorized your request into the following domains:
        </p>
      </div>
      <div className="flex flex-wrap justify-center gap-3">
        {categories?.map((category, index) => (
          <div
            key={index}
            className={`inline-flex items-center space-x-2 px-4 py-2 rounded-full border text-sm font-medium transition-smooth ${getCategoryColor(category)}`}
          >
            <Icon 
              name={getCategoryIcon(category)} 
              size={16} 
            />
            <span className="capitalize">{category}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoryChips;